import { render, staticRenderFns } from "./neighborhood-updater.vue?vue&type=template&id=1bc51558&scoped=true&"
import script from "./neighborhood-updater.vue?vue&type=script&lang=js&"
export * from "./neighborhood-updater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc51558",
  null
  
)

export default component.exports